import React from "react";
import PropTypes from "prop-types";
import EmbeddedBrowser from "./EmbeddedBrowser";

function TestEmbeddedBrowser() {
  const target =
    "https://top-step-sandbox.app.sandbox.netsuitesuiteprojectspro.com/dashboard.pl?app=ma;_login=1;uid=HmdtjPQm8BGNay1T58dWtQ;r=eVkQpXb2700";
  //const proxiedUrl = `https://oaproxy-c97fdd3a2995.herokuapp.com/proxy?url=${encodeURIComponent(target)}`;

  //const target2 = "https://www.google.com";
  return (
    <div>
      <h1>Embedded Netsuite Login</h1>
      <EmbeddedBrowser url={target} />
    </div>
  );
}

export default TestEmbeddedBrowser;

TestEmbeddedBrowser.propTypes = {};
